<template>
  <div>
    <facit-header></facit-header>
      <div class = "profile-div col-12">
        <h5 class="mt-3 mb-3"> Invoices </h5>
        <br><br>
        <b-table  striped hover
                  show-empty
                  empty-text="There are no invoices to show"
                  :fields="fields"
                  :items="devices"
                  :current-page="currentPage"
                  :per-page="perPage">
        <template slot="link" slot-scope="data">
              <a :href="data.value" target="_blank">
                <v-icon name="download"
                        base-class="icon-width">
                </v-icon></a>
        </template>
        </b-table>
        <b-pagination align="right"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      v-model="currentPage"
                      class="my-0" />
        <br><br>
      </div>
  </div>
</template>

<script>
import API from '@/api';
import FacitHeader from '@/components/header';
import Session from '@/Session';

export default {
  name: 'Invoices',
  components: { FacitHeader },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      devices: null,
      fields: [
        {
          key: 'id',
          label: 'Invoice Number',
          sortable: true,
          formatter: invoiceId => `IDC${invoiceId}`,
        },
        {
          key: 'transactionId',
          label: 'Transaction Number',
          sortable: true,
        },
        {
          key: 'date',
          label: 'Date',
          sortable: true,
          formatter: (value) => {
            const fullDate = new Date(value);
            let day = fullDate.getDate();
            let month = fullDate.getMonth() + 1;
            const year = fullDate.getFullYear();
            if (day < 10) { day = `0${day}`; }
            if (month < 10) { month = `0${month}`; }
            return `${day}-${month}-${year}`;
          },
        },
        {
          key: 'link',
          label: 'Action',
          sortable: false,
        },
      ],
    };
  },
  async created() {
    this.getDevices();
  },
  methods: {
    async getDevices() {
      const id = Session.getAccessToken().user.id;
      this.devices = await API.get(`Accounts/${id}/invoices?filter={"order": "id DESC"}`);
      this.totalRows = this.devices.length;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #d6700a;
}

input:focus + .slider {
  box-shadow: 0 0 1px #d6700a;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
}
.switch input {
  display:none;
}
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/invoice.vue